import { render, staticRenderFns } from "./GroupAddBtn.vue?vue&type=template&id=39086416&"
import script from "./GroupAddBtn.vue?vue&type=script&lang=js&"
export * from "./GroupAddBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports